import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-modal";
import { Link, Redirect } from "react-router-dom";
import NumberFormat from 'react-number-format';
import ReactTooltip from "react-tooltip";
import CopyToClipboard from 'react-copy-to-clipboard'
import Bounce from "react-reveal/Bounce";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import profileThumb from "../images/profileThumb.png";
import itemThumb from "../images/itemThumb.svg";
import { Helmet } from 'react-helmet-async';

import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";
import { bucket_route, getProductosPurchase, postFlag, SearchResults } from './API Functions';
import useModalProductos from './useModalProductos';
import ProductPrice from './Products/ProductPrice';

const customStylesShare = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        maxWidth: 400,
        padding: "40px",
        border: "none",
        borderRadius: 12,
    },
};

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "100%",
        padding: 0,
        border: "none",
        borderRadius: 0,
    },
};
var subtitle;

const customStylesFlag = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        padding: "40px",
        border: "none",
        borderRadius: 12,
    },
};


function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <svg className={className} onClick={onClick} width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="white" stroke-opacity="0.1" />
            <path d="M22 25L26 21L22 17" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M26 21L16 21" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <svg className={className} onClick={onClick} width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="41.5" y="41.5" width="41" height="41" rx="20.5" transform="rotate(-180 41.5 41.5)" stroke="white" stroke-opacity="0.1" />
            <path d="M20 17L16 21L20 25" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 21L26 21" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
};

function Search(keywords) {
    const data = {
        keywords: keywords
    }
    window.location.replace(`/search/${data.keywords}`)
}

function copiedPopUp() {
    const copiedPop = document.getElementById("copiedPop");
    copiedPop.classList.add("copiedPop-show");
    copiedPop.classList.add("copiedPop-exit");
}
function reportedPopUp() {
    const reportedPop = document.getElementById("reportedPop");
    reportedPop.classList.add("copiedPop-show");
    reportedPop.classList.add("copiedPop-exit");
}

function handlePurchase(producto) {
    getProductosPurchase(producto.id).then(res => {
        if (res) {
            window.open(`https://wa.me/52${producto.negocio.whatsap}?text=I'm%20inquiring%20about%20the%20product%20listing`)
        }
    })
}

function createFlag() {
    var status = false;

    const flag = JSON.parse(sessionStorage.getItem('flag_category'));
    const data = {
        motivo: flag.category,
        producto_id: flag.producto_id,
        negocio_id: flag.negocio_id
    }

    postFlag(data).then(res => {
        if (res) {
            status = true;
            return status;
        }
    })

}

function setCategory(category, producto_id, negocio_id) {
    const flag = {
        category: category,
        producto_id: producto_id,
        negocio_id: negocio_id
    }
    sessionStorage.setItem('flag_category', JSON.stringify(flag));
}

const url = window.location;

function navigateToProfile(negocio) {
    sessionStorage.setItem('profile_negocio', JSON.stringify(negocio));
    console.log(negocio)
    window.location.replace(`/${negocio.dominio_okki}`);
}

const ModalProductos = ({ isShowing, hide, flags, flagsShowing, share, shareShowing, image_loaded, loadImage, producto, tags }) => isShowing ? ReactDOM.createPortal(
    <React.Fragment>
        <Helmet>
                        <title>{`${producto.nombre} | Okki`}</title>
                        <meta name="title" content={producto.nombre} data-react-helmet="true" />
                        <meta name="description" content={producto.descripcion} data-react-helmet="true" />
                    </Helmet>
        <Modal
            isOpen={isShowing}
            onAfterOpen={false}
            onRequestClose={hide}
            style={customStyles}
            contentLabel="Example Modal"
        >
            <Link to="/" className="okkiLogo">
                <div>
                    <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M45.5925 39.8231C46.9383 39.8904 48.0654 38.8137 48.0654 37.468V35.1633C48.0654 34.8773 48.4019 34.7259 48.6206 34.9109L53.9869 39.3016C54.4243 39.6549 54.9458 39.8399 55.4841 39.8399C56.1738 39.8399 56.8467 39.5371 57.3009 38.982C58.1252 37.9726 57.9738 36.4923 56.9645 35.668L52.4224 31.9502C52.086 31.681 52.086 31.1764 52.4224 30.9072L56.9645 27.1894C57.9738 26.3651 58.1252 24.8848 57.3009 23.8754C56.4766 22.8661 54.9963 22.7147 53.9869 23.539L48.6206 27.9296C48.4019 28.1147 48.0654 27.9465 48.0654 27.6773V25.4231C48.0654 24.1614 47.0897 23.068 45.828 23.0007C44.4822 22.9334 43.3551 24.01 43.3551 25.3558V37.4007C43.3551 38.6623 44.3308 39.7558 45.5925 39.8231ZM36.4075 42.1782C35.0617 42.1109 33.9346 43.1876 33.9346 44.5334V46.838C33.9346 47.124 33.5981 47.2754 33.3794 47.0904L28.0131 42.6997C27.5757 42.3465 27.0542 42.1614 26.5159 42.1614C25.8262 42.1614 25.1533 42.4642 24.6991 43.0194C23.8748 44.0287 24.0262 45.5091 25.0355 46.3334L29.5776 50.0511C29.914 50.3203 29.914 50.825 29.5776 51.0941L25.0355 54.8119C24.0262 55.6362 23.8748 57.1165 24.6991 58.1259C25.5234 59.1352 27.0037 59.2866 28.0131 58.4623L33.3794 54.0717C33.5981 53.8866 33.9346 54.0549 33.9346 54.324V56.5614C33.9346 57.8231 34.9103 58.9165 36.172 58.9838C37.5178 59.0511 38.6449 57.9745 38.6449 56.6287V44.5838C38.6449 43.339 37.6692 42.2455 36.4075 42.1782ZM31.4112 23.0007C26.7682 23.0007 23 26.7689 23 31.4119C23 36.0549 26.7682 39.8231 31.4112 39.8231C36.0542 39.8231 39.8224 36.0549 39.8224 31.4119C39.8224 26.7689 36.0542 23.0007 31.4112 23.0007ZM31.4112 35.1128C29.3757 35.1128 27.7103 33.4474 27.7103 31.4119C27.7103 29.3764 29.3757 27.7109 31.4112 27.7109C33.4467 27.7109 35.1121 29.3764 35.1121 31.4119C35.1121 33.4474 33.4467 35.1128 31.4112 35.1128ZM56.6449 48.2343H44.5327C43.2374 48.2343 42.1776 49.2941 42.1776 50.5894C42.1776 51.8848 43.2374 52.9446 44.5327 52.9446H56.6449C57.9402 52.9446 59 51.8848 59 50.5894C59 49.2941 57.9402 48.2343 56.6449 48.2343Z" fill="white" />
                    </svg>
                </div>
            </Link>
            <div className="productModal">
                <div className="modalItem-respNav">

                    <Link to="/" className="okkiLogoModal">
                        <div className={producto.negocio.pro ? "modalItem-info__logoProMini" : null}>
                            <img src={producto.negocio ? `${bucket_route}${producto.negocio.imagen_url}` : profileThumb} alt="Perfil" onClick={() => { navigateToProfile(producto.negocio) }} />
                        </div>
                        {/* <div>
                                    <img src={producto.negocio ? `${route}/storage/${producto.negocio.imagen_url}` : profileThumb} alt="Perfil" onClick={() => { window.location.replace(`/${producto.negocio.dominio_okki}`) }} />
                                </div> */}
                    </Link>
                    <Link to="/" className="okkiLogoMobile">
                        <div>
                            <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M45.5925 39.8231C46.9383 39.8904 48.0654 38.8137 48.0654 37.468V35.1633C48.0654 34.8773 48.4019 34.7259 48.6206 34.9109L53.9869 39.3016C54.4243 39.6549 54.9458 39.8399 55.4841 39.8399C56.1738 39.8399 56.8467 39.5371 57.3009 38.982C58.1252 37.9726 57.9738 36.4923 56.9645 35.668L52.4224 31.9502C52.086 31.681 52.086 31.1764 52.4224 30.9072L56.9645 27.1894C57.9738 26.3651 58.1252 24.8848 57.3009 23.8754C56.4766 22.8661 54.9963 22.7147 53.9869 23.539L48.6206 27.9296C48.4019 28.1147 48.0654 27.9465 48.0654 27.6773V25.4231C48.0654 24.1614 47.0897 23.068 45.828 23.0007C44.4822 22.9334 43.3551 24.01 43.3551 25.3558V37.4007C43.3551 38.6623 44.3308 39.7558 45.5925 39.8231ZM36.4075 42.1782C35.0617 42.1109 33.9346 43.1876 33.9346 44.5334V46.838C33.9346 47.124 33.5981 47.2754 33.3794 47.0904L28.0131 42.6997C27.5757 42.3465 27.0542 42.1614 26.5159 42.1614C25.8262 42.1614 25.1533 42.4642 24.6991 43.0194C23.8748 44.0287 24.0262 45.5091 25.0355 46.3334L29.5776 50.0511C29.914 50.3203 29.914 50.825 29.5776 51.0941L25.0355 54.8119C24.0262 55.6362 23.8748 57.1165 24.6991 58.1259C25.5234 59.1352 27.0037 59.2866 28.0131 58.4623L33.3794 54.0717C33.5981 53.8866 33.9346 54.0549 33.9346 54.324V56.5614C33.9346 57.8231 34.9103 58.9165 36.172 58.9838C37.5178 59.0511 38.6449 57.9745 38.6449 56.6287V44.5838C38.6449 43.339 37.6692 42.2455 36.4075 42.1782ZM31.4112 23.0007C26.7682 23.0007 23 26.7689 23 31.4119C23 36.0549 26.7682 39.8231 31.4112 39.8231C36.0542 39.8231 39.8224 36.0549 39.8224 31.4119C39.8224 26.7689 36.0542 23.0007 31.4112 23.0007ZM31.4112 35.1128C29.3757 35.1128 27.7103 33.4474 27.7103 31.4119C27.7103 29.3764 29.3757 27.7109 31.4112 27.7109C33.4467 27.7109 35.1121 29.3764 35.1121 31.4119C35.1121 33.4474 33.4467 35.1128 31.4112 35.1128ZM56.6449 48.2343H44.5327C43.2374 48.2343 42.1776 49.2941 42.1776 50.5894C42.1776 51.8848 43.2374 52.9446 44.5327 52.9446H56.6449C57.9402 52.9446 59 51.8848 59 50.5894C59 49.2941 57.9402 48.2343 56.6449 48.2343Z" fill="black" />
                            </svg>
                            {/* <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0)">
                                            <path d="M20.0822 14.9535C21.2785 15.0133 22.2804 14.0563 22.2804 12.86V10.8114C22.2804 10.5572 22.5794 10.4226 22.7738 10.5871L27.5439 14.4899C27.9327 14.804 28.3963 14.9684 28.8748 14.9684C29.4879 14.9684 30.086 14.6993 30.4897 14.2058C31.2224 13.3086 31.0878 11.9927 30.1907 11.26L26.1533 7.95536C25.8542 7.7161 25.8542 7.26751 26.1533 7.02825L30.1907 3.72358C31.0878 2.99087 31.2224 1.67498 30.4897 0.777788C29.757 -0.119409 28.4411 -0.253988 27.5439 0.478722L22.7738 4.38153C22.5794 4.54601 22.2804 4.39648 22.2804 4.15723V2.15349C22.2804 1.03199 21.4131 0.0600306 20.2916 0.000217531C19.0953 -0.0595955 18.0935 0.897414 18.0935 2.09368V12.8002C18.0935 13.9217 18.9607 14.8937 20.0822 14.9535ZM11.9178 17.0469C10.7215 16.9871 9.71963 17.9441 9.71963 19.1404V21.189C9.71963 21.4432 9.42056 21.5778 9.22617 21.4133L4.45607 17.5105C4.06729 17.1965 3.60374 17.032 3.12523 17.032C2.51215 17.032 1.91402 17.3011 1.51028 17.7946C0.77757 18.6918 0.91215 20.0077 1.80935 20.7404L5.84673 24.0451C6.14579 24.2843 6.14579 24.7329 5.84673 24.9722L1.80935 28.2768C0.91215 29.0096 0.77757 30.3254 1.51028 31.2226C2.24299 32.1198 3.55888 32.2544 4.45607 31.5217L9.22617 27.6189C9.42056 27.4544 9.71963 27.604 9.71963 27.8432V29.832C9.71963 30.9535 10.5869 31.9254 11.7084 31.9853C12.9047 32.0451 13.9065 31.0881 13.9065 29.8918V19.1853C13.9065 18.0787 13.0393 17.1068 11.9178 17.0469ZM7.47664 0.000217531C3.34953 0.000217531 0 3.34975 0 7.47685C0 11.604 3.34953 14.9535 7.47664 14.9535C11.6037 14.9535 14.9533 11.604 14.9533 7.47685C14.9533 3.34975 11.6037 0.000217531 7.47664 0.000217531ZM7.47664 10.7666C5.66729 10.7666 4.18692 9.2862 4.18692 7.47685C4.18692 5.66751 5.66729 4.18713 7.47664 4.18713C9.28598 4.18713 10.7664 5.66751 10.7664 7.47685C10.7664 9.2862 9.28598 10.7666 7.47664 10.7666ZM29.9065 22.4301H19.1402C17.9888 22.4301 17.0467 23.3722 17.0467 24.5236C17.0467 25.675 17.9888 26.617 19.1402 26.617H29.9065C31.0579 26.617 32 25.675 32 24.5236C32 23.3722 31.0579 22.4301 29.9065 22.4301Z" fill="#111111" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0">
                                                <rect width="32" height="32" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg> */}


                        </div>
                    </Link>
                    <a onClick={hide}>
                        <svg className="modalCloseButton" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="#EEEEEE" />
                            <path d="M25.2422 16.7574L16.7569 25.2427" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M25.2431 25.2427L16.7578 16.7574" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </a>
                </div>
                <div className="row rowLightbox">
                    <div className="seven columns">
                        {
                            //<div className="modalItem-cover" style={{ background: `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${producto.principal_image ? `${producto.principal_image.url}` : itemThumb})` }}>   
                        }
                        <div className="modalItem-cover" style={{ background: `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${producto.principal_image ? `${bucket_route}${producto.principal_image.path}` : itemThumb})` }}>

                            <div className="modalItem-coverBlur"></div>
                            <div className="modalItem-cover__sliderContainer">
                                <Slider {...settings}>
                                    {producto.images.map(image => (
                                        <div>
                                        <img style={image_loaded ? {} : {display: "none"}} src={image ? `${bucket_route}${image.path}` : itemThumb} 
                                        onLoad={loadImage}
                                        />
                                        {
                                        image_loaded ?
                                        null
                                        :
                                        <div class="containerSpinner">
                                            <div class="circle"></div>
                                        </div>
                                        }
                                         </div>
                                        
                                    ))

                                    }

                                </Slider>
                            </div>

                        </div>

                    </div>

                    <div className="five columns">
                        <div className="modalItem-info">
                            <div className="modalItem-info__logo">
                                <div className={producto.negocio.pro ? "modalItem-info__logoPro" : null}>
                                    <img data-tip={`${producto.negocio.nombre}`} src={producto.negocio ? `${bucket_route}${producto.negocio.imagen_url}` : profileThumb} alt="Perfil" onClick={() => { navigateToProfile(producto.negocio) }} />

                                    {/* <img className="rowProfile-thumb" src={negocio.imagen_url !== '' ? `${route}/storage/${negocio.imagen_url}` : profileThumb2} /> */}
                                </div>
                                {/* <img data-tip={`${producto.negocio.nombre}`} src={producto.negocio ? `${route}/storage/${producto.negocio.imagen_url}` : profileThumb} alt="Perfil" onClick={() => { window.location.replace(`/${producto.negocio.dominio_okki}`) }} /> */}
                                <div className="modalItem-info__actions">
                                    <svg data-tip="Reportar" onClick={() => { flags() }}
                                        className="modalItem-info__actions-btn" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="31" height="31" rx="5.5" fill="white" stroke="#EEEEEE" />
                                        <rect x="6" y="6" width="20" height="20" fill="white" />
                                        <path d="M10 10L10 23" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M22 18.0619C17.9714 21.3115 14.0286 14.8124 10 18.0619C10 15.354 10 12.646 10 9.93806C14.0286 6.68852 17.9714 13.1876 22 9.93806C22 12.646 22 15.354 22 18.0619Z" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <svg data-tip="Compartir" onClick={() => { share() }}
                                        className="modalItem-info__actions-btn" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="31" height="31" rx="5.5" fill="white" stroke="#EEEEEE" />
                                        <rect x="6" y="6" width="20" height="20" fill="white" />
                                        <path d="M19.4284 13.4286L15.9999 10L12.5713 13.4286" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 17.7144V22.0001H22V17.7144" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 10V17.7143" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <ReactTooltip className="tooltipStyle" multiline="true" place="top" type="dark" effect="solid" />

                                </div>
                            </div>
                            <hr />
                            <div className="modalItem-info__nameRow">
                                <h5>{producto.nombre}</h5>
                                <div className="modalItem-info__actions">
                                    <svg data-tip="Reportar" onClick={() => { flags() }} className="modalItem-info__actions-btn" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="31" height="31" rx="5.5" fill="white" stroke="#EEEEEE" />
                                        <rect x="6" y="6" width="20" height="20" fill="white" />
                                        <path d="M10 10L10 23" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M22 18.0619C17.9714 21.3115 14.0286 14.8124 10 18.0619C10 15.354 10 12.646 10 9.93806C14.0286 6.68852 17.9714 13.1876 22 9.93806C22 12.646 22 15.354 22 18.0619Z" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <svg data-tip="Compartir" onClick={() => { share() }} className="modalItem-info__actions-btn" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="31" height="31" rx="5.5" fill="white" stroke="#EEEEEE" />
                                        <rect x="6" y="6" width="20" height="20" fill="white" />
                                        <path d="M19.4284 13.4286L15.9999 10L12.5713 13.4286" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 17.7144V22.0001H22V17.7144" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 10V17.7143" stroke="#66666A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <ReactTooltip className="tooltipStyle" multiline="true" place="top" type="dark" effect="solid" />

                                        </div>
                                    </div>
                                    <ProductPrice
                                    producto={producto}
                                    />
                            <button className="button modalItem-info__buttonMobile" onClick={() => { handlePurchase(producto) }}                            >
                                Comprar
                                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="21" cy="21" r="21" fill="black" fill-opacity="0" />
                                    <path id="bagBg" d="M29.6739 27.7172C29.846 28.922 28.9111 30 27.694 30H14.306C13.0889 30 12.154 28.922 12.3261 27.7172L13.7547 17.7172C13.8954 16.7319 14.7393 16 15.7346 16H26.2654C27.2607 16 28.1046 16.7319 28.2453 17.7172L29.6739 27.7172Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />

                                    <path id="zipper" d="M25 20C25 22.2 23.2 24 21 24C18.8 24 17 22.2 17 20" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />

                                    <path id="handle" d="M17 16C17 13.8 18.8 12 21 12C23.2 12 25 13.8 25 16" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />

                                </svg>

                            </button>
                            <p className="modalItem-info__about">
                                {producto.descripcion}
                            </p>
                            <div className="modalItem-info__aboutShipping" >
                                {producto.negocio.envios[0].id == 2 ?
                                    <p className="itemTagAlt">{'A convenir'}</p>
                                    :
                                    <p className="itemTagAlt">
                                        {"Envío "}
                                        <NumberFormat decimalScale={2} isNumericString={true} value={producto.negocio.precio_envio} displayType={'text'} thousandSeparator={true} prefix={' $'} />
                                    </p>
                                }
                               
                            </div>
                            <br/>
                            <div style={{ display: "flex", flexWrap: "wrap" }} className="rowProfile-bottom__tags">
                                 
                            <p className="itemTagAlt">{producto.negocio.estado ? producto.negocio.estado.name : ''}</p>
                              <p className="itemTagAlt">{producto.negocio.ciudad ? producto.negocio.ciudad.nombre : ''}</p>
                            </div>
                            <button className="button modalItem-info__button" onClick={() => { window.open(`https://wa.me/52${producto.negocio.whatsap}?text=${producto.mensaje_privado ? producto.mensaje_privado.replace(/ /g, '%20') : 'Estoy%20interesad@%20en%20el%20producto'}%20${producto.nombre}`) }}>
                                Comprar
                                        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="21" cy="21" r="21" fill="black" fill-opacity="0" />
                                    <path id="bagBg" d="M29.6739 27.7172C29.846 28.922 28.9111 30 27.694 30H14.306C13.0889 30 12.154 28.922 12.3261 27.7172L13.7547 17.7172C13.8954 16.7319 14.7393 16 15.7346 16H26.2654C27.2607 16 28.1046 16.7319 28.2453 17.7172L29.6739 27.7172Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />

                                    <path id="zipper" d="M25 20C25 22.2 23.2 24 21 24C18.8 24 17 22.2 17 20" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />

                                    <path id="handle" d="M17 16C17 13.8 18.8 12 21 12C23.2 12 25 13.8 25 16" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />

                                </svg>
                            </button>
                            <hr style={{ marginTop: 20 }} />
                            <div className="modalItem-info__tags" style={{ textTransform: 'capitalize' }}>

                                {tags.map(tag => (
                                    <a className="itemTag" onClick={() => { Search(tag) }}>
                                        {tag}
                                    </a>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="copiedPop" className="draftView-bottom copiedPop">
                <Bounce bottom>
                    <p className="draftView-message">¡El enlace se ha copiado al portapapeles!</p>
                </Bounce>
            </div>
            <div id="reportedPop" className="draftView-bottom copiedPop">
                <Bounce bottom>
                    <p className="draftView-message">Reporte envíado. Gracias 🖖</p>
                </Bounce>
            </div>


        </Modal>
        <Modal
            isOpen={flagsShowing}
            onAfterOpen={false}
            onRequestClose={flags}
            style={customStylesFlag}
        >
            <svg className="flagModal-close" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="white" stroke-opacity="0.25" />
                <path d="M25.2422 16.7573L16.7569 25.2426" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25.2431 25.2426L16.7578 16.7573" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div className="flagModal">
                <p
                    className="titleMinSub  text-center"
                >
                    Reportar contenido
                </p>
                <label class="radioContainer flagModal-row">
                    <input
                        type="radio"
                        name="category"
                        value="Spam"
                        onChange={e => { setCategory(e.target.value, producto.id, producto.negocio_id) }}
                    />
                    <span className="checkmark"></span>
                                                        Spam

                        </label>
                <label class="radioContainer flagModal-row">
                    Desnudos o pornografía
                <input
                        type="radio"
                        name="category"
                        value="Desnudos o pornografía"
                        onChange={e => { setCategory(e.target.value, producto.id, producto.negocio_id) }}
                    />
                    <span className="checkmark"></span>
                </label>
                <label class="radioContainer flagModal-row">
                    Inapropiado
                <input
                        type="radio"
                        name="category"
                        value="Inapropiado"
                        onChange={e => { setCategory(e.target.value, producto.id, producto.negocio_id) }}
                    />
                    <span className="checkmark"></span>
                </label>
                <label class="radioContainer flagModal-row">
                    Violencia gráfica
                <input
                        type="radio"
                        name="category"
                        value="Violencia gráfica"
                        onChange={e => { setCategory(e.target.value, producto.id, producto.negocio_id) }}
                    />
                    <span className="checkmark"></span>
                </label>
                <label class="radioContainer flagModal-row">
                    Derechos de autor
                <input
                        type="radio"
                        name="category"
                        value="Derechos de autor"
                        onChange={e => { setCategory(e.target.value, producto.id, producto.negocio_id) }}
                    />
                    <span className="checkmark"></span>
                </label>
                <br />
                <button
                    className="button u-pull-right aButton flagModal-button"
                    onClick={() => {
                        createFlag();
                        flags();
                        reportedPopUp();
                    }}
                >
                    Reportar
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 14L15 10L11 6" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15 10L5 10" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </button>
            </div>

        </Modal>
        <Modal
            isOpen={shareShowing}
            onAfterOpen={false}
            onRequestClose={share}
            style={customStylesShare}
        >
            <div className="shareModal">
                <FacebookShareButton resetButtonStyle={false} url={url} className="shareModal-button facebook">
                    Facebook
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 18H6C3.8 18 2 16.2 2 14V6C2 3.8 3.8 2 6 2H14C16.2 2 18 3.8 18 6V14C18 16.2 16.2 18 14 18Z" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14 6H13C11.9 6 11 6.9 11 8V18" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9 10H13" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </FacebookShareButton>
                <TwitterShareButton resetButtonStyle={false} url={url} className="shareModal-button twitter">
                    Twitter
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.2222 5C16.0131 4.8 15.8039 4.6 15.5948 4.5C15.0719 4.2 14.4444 4 13.817 4C12.5621 4 11.5163 4.8 10.9935 5.8C10.7843 6.2 10.6797 6.6 10.6797 7C10.6797 7.2 10.6797 7.3 10.6797 7.5C10.4706 7.5 10.2614 7.5 10.1569 7.5C7.85621 7.5 5.76471 6.3 4.71895 4.5C4.19608 5.4 3.88235 6.4 3.88235 7.5C3.88235 10.1 5.66013 12.4 8.16993 13.2C7.01961 14.1 5.55556 14.5 3.88235 14.5C3.2549 14.5 2.62745 14.4 2 14.3C3.56863 15.4 5.45098 16 7.54248 16C12.7712 16 16.9542 12 16.9542 7L18 5H16.2222V5Z" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </TwitterShareButton>
                <WhatsappShareButton resetButtonStyle={false} url={url} className="shareModal-button whatsapp">
                    Whatsapp
                  <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.7069 1.76386C5.01564 1.0763 3.9469 1.07872 3.2583 1.77114L2.56215 2.47114C1.72741 3.3105 1.25 4.50017 1.25 5.6V6C1.25 6.00753 1.25011 6.01506 1.25034 6.02259C1.46096 13.0116 6.94362 18.5372 13.8113 18.7496C13.819 18.7499 13.8268 18.75 13.8345 18.75H14.3318C15.5658 18.75 16.7427 18.1393 17.5487 17.3289L18.0893 16.7853C19.0084 16.1523 18.8775 14.9073 18.2448 14.2711L16.1564 12.1711C15.4654 11.4763 14.3915 11.4763 13.7005 12.1711L12.6643 13.2131C11.8705 12.8653 11.1073 12.4483 10.418 11.9092C10.3942 11.8906 10.3693 11.8734 10.3434 11.8578C9.45651 11.3227 8.63459 10.5034 7.98582 9.5715C7.97039 9.54934 7.95378 9.52803 7.93606 9.50767C7.4033 8.89543 6.99394 8.21215 6.65367 7.38418L7.80262 6.22886C8.49137 5.53631 8.49137 4.46369 7.80262 3.77114L7.78957 3.75832L5.7069 1.76386ZM4.48624 2.75C4.44415 2.75 4.38496 2.76544 4.32189 2.82886L3.62574 3.52886C3.06819 4.0895 2.75 4.89983 2.75 5.6V5.98784C2.94252 12.1896 7.79446 17.0568 13.8463 17.25H14.3318C15.0867 17.25 15.8988 16.8607 16.4851 16.2711L17.0818 15.6711C17.1251 15.6276 17.1736 15.5895 17.2262 15.5578C17.2368 15.5514 17.2387 15.5476 17.2401 15.5452C17.2426 15.5406 17.2486 15.5271 17.2498 15.502C17.2525 15.4454 17.2287 15.3765 17.1813 15.3289L15.0928 13.2289C15.0297 13.1654 14.9705 13.15 14.9285 13.15C14.8864 13.15 14.8272 13.1654 14.7641 13.2289L13.3718 14.6289C13.1593 14.8425 12.8397 14.9083 12.5601 14.7958C11.5404 14.3857 10.4898 13.8622 9.5295 13.1185C8.45492 12.461 7.50942 11.5042 6.77784 10.4615C6.02384 9.5867 5.49174 8.61079 5.07379 7.45506C4.97511 7.18219 5.04268 6.87688 5.2473 6.67113L6.73904 5.17114C6.8022 5.10763 6.81918 5.04618 6.81918 5C6.81918 4.95499 6.80305 4.89547 6.74374 4.83367L4.66365 2.84168L4.6506 2.82886C4.58753 2.76544 4.52834 2.75 4.48624 2.75Z"
                            fill="#66666A"
                        />
                    </svg>
                </WhatsappShareButton>
                <CopyToClipboard text={url}>
                    <a onClick={() => { copiedPopUp() }} className="shareModal-button link">
                        Copiar
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.1973 8.76479C9.7236 7.30073 7.421 7.30073 5.94733 8.76479L4.10525 10.6864C2.63158 12.1504 2.63158 14.438 4.10525 15.9021C5.57892 17.3661 7.88152 17.3661 9.35519 15.9021" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.71094 11.2353C10.1846 12.6994 12.4872 12.6994 13.9609 11.2353L15.8951 9.31374C17.3687 7.84968 17.3687 5.5621 15.8951 4.09804C14.4214 2.63399 12.1188 2.63399 10.6451 4.09804" stroke="#66666A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                </CopyToClipboard>
            </div>
        </Modal>


    </React.Fragment>, document.body
) : null;

export default ModalProductos;